const handlers = new Map();

/**
 * Register a command handler owned by the bridge provider.
 * @param {string} type command type
 * @param {Function} handler command handler
 * @return {Function} unregister callback
 */
export function registerCommand(type, handler) {
	handlers.set(type, handler);
	return () => {
		if (handlers.get(type) === handler) handlers.delete(type);
	};
}

/**
 * Resolve an allowlisted command handler.
 * @param {string} type command type
 * @return {Function|null} registered handler
 */
export function getCommandHandler(type) {
	return handlers.get(type) || null;
}
